// HonestUnavailableCard — surfaces a backend gap to the operator without
// faking data. Use anywhere a real engine route is not yet shipped (or a
// dependency like end-to-end smoke is pending).
//
// Convention: `route` is a verbatim quote of the missing endpoint. `handoffPath`
// points at the coordination doc that explains the gap. `reason` is optional
// extra context.

import type { ReactNode } from 'react';

export interface HonestUnavailableCardProps {
  title: string;
  route: string;
  handoffPath?: string;
  reason?: ReactNode;
}

export function HonestUnavailableCard({
  title,
  route,
  handoffPath,
  reason,
}: HonestUnavailableCardProps) {
  return (
    <div
      className="sp-widget"
      style={{
        borderStyle: 'dashed',
        borderColor: 'var(--sp-warn)',
      }}
    >
      <div className="sp-widget-header" style={{ color: 'var(--sp-warn)' }}>
        <span>{title}</span>
        <span style={{ fontSize: 10, fontWeight: 400, letterSpacing: 0 }}>
          unavailable
        </span>
      </div>
      <div className="sp-widget-body" style={{ padding: 12, fontSize: 12 }}>
        <div style={{ color: 'var(--sp-text-muted)' }}>
          This surface depends on a backend route that has not shipped yet. We
          do not fake data here.
        </div>
        <div
          className="mono"
          style={{
            marginTop: 8,
            padding: '4px 6px',
            borderRadius: 3,
            background: 'var(--sp-bg-subtle, rgba(255,255,255,0.04))',
            color: 'var(--sp-text-dim)',
            fontSize: 11,
            wordBreak: 'break-all',
          }}
        >
          {route}
        </div>
        {reason ? (
          <div style={{ marginTop: 8, color: 'var(--sp-text-muted)' }}>{reason}</div>
        ) : null}
        {handoffPath ? (
          <div
            className="mono"
            style={{
              marginTop: 8,
              fontSize: 11,
              color: 'var(--sp-text-dim)',
            }}
          >
            See: {handoffPath}
          </div>
        ) : null}
      </div>
    </div>
  );
}
